module.exports = __webpack_public_path__ + "img/sidebar-1.23832d31.jpg";